import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from 'react';
import FinalMolGrid from '../../../../../components/FinalMolGrid/FinalMolGrid';
import Buttons from '../../../../../components/ui/button/Buttons';
import { AdditionalAddOnsData } from '../data/AdditionalAddOn.Data';
// import { v4 as uuidv4 } from 'uuid';
import BasicDetailContext from '../../../utils/BasicDetailContext';

const AdditionalAddOns = () => {
  const additionalAddOnsRef = useRef();
  const { eventId, addOnsData, setAddOnsData } = useContext(BasicDetailContext);

  // useEffect(() => {
  //   setAddOnsData([
  //     {
  //       id: 1,
  //       eventAddOnPriceId: 0,
  //       eventId: eventId,
  //       eventAddOnType: "Pen",
  //       eventAddOnPrice: 5,
  //     },
  //     {
  //       id: 2,
  //       eventAddOnPriceId: 0,
  //       eventId: eventId,
  //       eventAddOnType: "Diary",
  //       eventAddOnPrice: 5,
  //     },
  //   ])
  // }, [])

  const handleAdd = () => {
    console.log("handleAdd Function");
    let temp = [...addOnsData]
    temp.push({
      // id: uuidv4(),
      eventAddOnPriceId: 0,
      eventId: eventId,
      eventAddOnType: "",
      eventAddOnPrice: 0,
    })
    setAddOnsData(temp)
  }

  const handleEditClick = (data, rowIndex) => {
    let newGridData = [...addOnsData];
    newGridData[rowIndex] = { ...addOnsData[rowIndex], ...data };
    setAddOnsData(newGridData);
  };

  const handleDeleteClick = (data, index) => {
    let newGridData = [...addOnsData];
    newGridData.splice(index, 1);
    setAddOnsData(newGridData);
  };

  const handleSave = () => {
    console.log("handle Save Function", addOnsData)
    // let requst = {
    //   AddEditPricingDetails: addOnsData
    // }

  };

  const actionHandler = {
    EDIT: handleEditClick,
    DELETE: handleDeleteClick
  };

  return (
    <div>
      {/* <h5>AdditionalAddOns Component :</h5><br /> */}
      <FinalMolGrid
        ref={additionalAddOnsRef}
        dataSource={addOnsData}
        configuration={AdditionalAddOnsData}
        onRowDataUpdate={handleEditClick}
        onActionChange={actionHandler}
      />
      <div className="multi-btn-sec justify-content-between mt-1">
        <Buttons
          onClick={handleAdd}
          buttonText={"Add Add-On"}
          buttonTypeClassName="btn theme-btn my-2"
          isLoading={false}
        />
      </div>
      {/* <Buttons
        onClick={handleSave}
        buttonTypeClassName="btn theme-btn my-2"
        buttonText={"Save"}
      /> */}
    </div>
  );
};

export default AdditionalAddOns;
